<template>
  <div>
    <v-container>
      <v-card elevation="7" outlined>
        <v-col cols="12" class="text-center headline">
          <span>เพิ่มรายการคำถามที่ต้องการ</span>
        </v-col>
        <v-card-title>
          <v-col cols="6" class="text-left">
            <v-btn @click="previousPage"> ย้อนกลับ </v-btn>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn @click="addNewAnswer" color="success"> บันทึกข้อมูล </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-form ref="formAddQuiz">
            <v-row class="px-3">
              <v-col cols="4">
                <v-autocomplete
                  outlined
                  label="ชุดที่"
                  :items="SETFORQUIZ"
                  item-text="ID"
                  item-value="VALUE"
                  v-model="SETQZNUMBER"
                  :rules="SETNUMBEROFQZ"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  outlined
                  label="สัปดาห์"
                  :items="FIXWEEK"
                  item-text="ID"
                  item-value="VALUE"
                  v-model="SETWEEK"
                  :rules="SETWEEKOFQZ"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  outlined
                  label="ซีซั่น"
                  :items="SEASON"
                  item-text="NAME"
                  item-value="ID"
                  v-model="SETSEASON"
                  :rules="SETSEASONOFQZ"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                v-for="(qa, index) in questionsAndAnswers"
                :key="index"
              >
                <v-row>
                  <v-col cols="6" class="mb-4">
                    <v-btn @click="addQuestion" class="" color="primary"
                      >เพิ่มคำถาม</v-btn
                    >
                    <v-btn
                      @click="addLink(qa, index)"
                      color="success"
                      class="ml-5"
                      >เพิ่มลิงค์</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row
                  class="mt-3"
                  v-if="
                    toggleTrue === true &&
                    questionsAndAnswers[index].vdostatus === true
                  "
                >
                  <v-col class="mx-3">
                    <v-row>
                      <v-col cols="4" class="pl-0">
                        <v-text-field
                          outlined
                          v-model="qa.link"
                          label="ลิงค์วิดีโอ"
                          :rules="[
                            (v) =>
                              /^(https?:\/\/)?(www\.)?youtu\.?be(.com)?\/.+/.test(
                                v
                              ) || 'ต้องเป็นลิงค์จาก Youtube เท่านั้น',
                          ]"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        cols="3"
                        class="pl-0 text-center d-flex align-start"
                      >
                        <v-btn
                          class="mx-1 mt-3"
                          color="red"
                          @click="removeLink(index)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="11">
                    <v-text-field
                      outlined
                      v-model="qa.question"
                      :label="'คำถามข้อที่ ' + (index + 1)"
                      :rules="questionRules"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="1" class="px-0 pb-10 d-flex align-center">
                    <v-btn
                      class="pa-0"
                      color="red"
                      @click="removeQuestion(qa, index)"
                    >
                      <v-icon> mdi-trash-can-outline </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-textarea
                  outlined
                  label="คำแนะนำ"
                  v-model="qa.hint"
                ></v-textarea>
                <v-btn @click="addAnswer(index)" color="success"
                  >เพิ่มคำตอบ</v-btn
                >

                <span class="px-5 text-warning subtitle-1"
                  >ให้
                  <span class="mdi mdi-checkbox-marked-outline">
                    ในช่องว่างเพื่อเลือกคำตอบที่ถูกต้อง</span
                  ></span
                >

                <v-col
                  v-for="(answer, answerIndex) in qa.answers"
                  :key="'B' + answerIndex"
                >
                  <v-row>
                    <v-col cols="4" class="pl-0">
                      <v-text-field
                        outlined
                        v-model="answer.text"
                        label="คำตอบ"
                        :rules="answerRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        outlined
                        v-model="answer.score"
                        label="คะแนน"
                        type="number"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1" class="pr-0 mb-5 d-flex align-center">
                      <v-checkbox v-model="answer.checkbox"></v-checkbox>
                    </v-col>
                    <v-col
                      cols="3"
                      class="pl-0 mb-5 text-center d-flex align-center"
                    >
                      <v-btn
                        class="mx-1"
                        color="red"
                        @click="removeAnswer(index, answerIndex)"
                      >
                        <v-icon> mdi-trash-can-outline </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <hr
                  style="
                    height: 2px;
                    border-width: 0;
                    color: gray;
                    background-color: gray;
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      row: 0,
      SEASON: [],
      selectClip: false,
      addQuiz: false,
      SETQZNUMBER: 0,
      SETWEEK: null,
      SETSEASON: null,
      checkbox: false,
      toggleTrue: false,
      selectForm: [
        {
          text: "",
          value: "",
        },
        {
          text: "คำถามไม่มีวิดีโอ",
          value: 0,
        },
        {
          text: "คำถามมีลิงค์วิดีโอ",
          value: 1,
        },
      ],
      choice: null,
      //rules
      valid: true,
      SETNUMBEROFQZ: [
        (v) => !!v || "กรุณาเลือกชุดคำถามที่ต้องการ 1-10",
        // (v) => (v && v.length == 0) || "เลือกชุดคำถามที่ต้องการ 1-10",
      ],
      SETWEEKOFQZ: [
        (v) => !!v || "กรุณาเลือกสัปดาห์ที่ต้องการ 1-12",
        // (v) => (v && v.length == 0) || "เลือกสัปดาห์ที่ต้องการ 1-12",
      ],
      SETSEASONOFQZ: [
        (v) => !!v || "กรุณาเลือกซีซั่นที่ต้องการอีกครั้ง",
        // (v) => (v && v.length == 0) || "เลือกซีซั่นที่ต้องการอีกครั้ง",
      ],
      questionRules: [
        (v) => !!v || "กรุณากรอกคำถามที่ต้องการอีกครั้ง",
        // (v) => (v && v.length == 0) || "กรอกคำถามที่ต้องการอีกครั้ง",
      ],
      hintRules: [
        (v) => !!v || "กรุณากรอกคำแนะนำต้องการอีกครั้ง",
        // (v) => (v && v.length == 0) || "กรอกคำแนะนำต้องการอีกครั้ง",
      ],
      answerRules: [
        (v) => !!v || "กรุณากรอกคำตอบที่ต้องการอีกครั้ง",
        // (v) => (v && v.length == 0) || "กรอกคำตอบที่ต้องการอีกครั้ง",
      ],

      FIXWEEK: [
        { ID: 1, VALUE: 1 },
        { ID: 2, VALUE: 2 },
        { ID: 3, VALUE: 3 },
        { ID: 4, VALUE: 4 },
        { ID: 5, VALUE: 5 },
        { ID: 6, VALUE: 6 },
        { ID: 7, VALUE: 7 },
        { ID: 8, VALUE: 8 },
        { ID: 9, VALUE: 9 },
        { ID: 10, VALUE: 10 },
        { ID: 11, VALUE: 11 },
        { ID: 12, VALUE: 12 },
      ],

      SETFORQUIZ: [
        { ID: 1, VALUE: 1 },
        { ID: 2, VALUE: 2 },
        { ID: 3, VALUE: 3 },
        { ID: 4, VALUE: 4 },
        { ID: 5, VALUE: 5 },
        { ID: 6, VALUE: 6 },
        { ID: 7, VALUE: 7 },
        { ID: 8, VALUE: 8 },
        { ID: 9, VALUE: 9 },
        { ID: 10, VALUE: 10 },
      ],

      //formQZ
      questionsAndAnswers: [
        {
          question: "",
          link: "",
          hint: "",
          answers: [{ text: "", score: 0, checkbox: false }],
          vdostatus: false,
        },
      ],
      addNewWeek: null,
      newAnswer: [],
      toggleTrue: false,
    };
  },

  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    async listAllSeason() {
      this.$guest_api
        .get("/only-season")
        .then((res) => {
          this.SEASON = res.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    addQuestion() {
      this.questionsAndAnswers.push({
        question: "",
        link: "",
        hint: "",
        answers: [{ text: "", score: 0, checkbox: false }],
        vdostatus: false,
      });
    },
    async addNewAnswer() {
      if (!this.$refs.formAddQuiz.validate()) {
        this.$swal({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          text: "โปรดลองใหม่อีกครั้ง",
        });
      } else {
        this.LOADER(true);
        this.$token_api
          .post("/add-quiz", {
            param: this.questionsAndAnswers,
            setNumber: this.SETQZNUMBER,
            week: this.SETWEEK,
            season: this.SETSEASON,
          })
          .then((res) => {
            this.$swal({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            });
            this.LOADER(false);
            this.$router.replace("/index/quiz-manage");
            this.SETQZNUMBER = null;
            this.questionsAndAnswers = null;
            this.$refs.formAddQuiz.reset();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async addAnswer(questionIndex) {
      this.questionsAndAnswers[questionIndex].answers.push({
        text: "",
        score: 0,
        checkbox: false,
      });
    },
    addLink(qa, index) {
      this.toggleTrue = true;
      this.questionsAndAnswers[index].vdostatus = true;
    },
    async removeAnswer(questionIndex, answerIndex) {
      this.questionsAndAnswers[questionIndex].answers.splice(answerIndex, 1);
    },
    async removeLink(questionIndex) {
      this.questionsAndAnswers[questionIndex].link = "";
      this.toggleTrue = false;
    },
    async removeQuestion(qa) {
      this.questionsAndAnswers.splice(qa, 1);
    },

    async previousPage() {
      this.$refs.formAddQuiz.reset();
      this.$router.push("/index/quiz-manage");
    },
  },
  mounted() {
    this.listAllSeason();
  },
};
</script>

<style scoped>
.text-warning {
  color: red;
}
</style>